function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimplefiligreeSaveselection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-b49823a2-6d62-4c2c-966d-c294222e2895",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74.55 74.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "73.55 73.55 1 73.55 1 1 64.89 1 73.55 9.08 73.55 73.55",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.93,1H55.62V24.71c0,2.14-1.74,3.88-3.88,3.88H22.81c-2.14,0-3.88-1.74-3.88-3.88V1h0Z",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.4,
    y: 7.36,
    width: 6.14,
    height: 14.87,
    rx: 0.12,
    ry: 0.12,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.32,
    y: 38.78,
    width: 49.91,
    height: 24.28,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.49,
    y1: 45.94,
    x2: 52.07,
    y2: 45.94,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.49,
    y1: 51.38,
    x2: 52.07,
    y2: 51.38,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.49,
    y1: 56.82,
    x2: 52.07,
    y2: 56.82,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplefiligreeSaveselection);
export default __webpack_public_path__ + "static/media/simple filigree - save selection.eafb527693327af4930a83989230e0a7.svg";
export { ForwardRef as ReactComponent };